export default "__VITE_ASSET__65c051ba__"